import { Action } from '@ngrx/store';
import { Department } from '../department/department.model';

export enum DepartmentApiActionTypes {
  LoadDepartmentsApi = '[Department API] Load Departments',
  LoadDepartmentsSuccessApi = '[Department API] Load Departments Success',
  LoadDepartmentsFailureApi = '[Department API] Load Departments Failure',
  LoadDepartmentApi = '[Department API] Load Department',
  LoadDepartmentSuccessApi = '[Department API] Load Department Success',
  LoadDepartmentFailureApi = '[Department API] Load Department Failure',
  CreateDepartmentApi = '[Department API] Create Department',
  CreateDepartmentSuccessApi = '[Department API] Create Department Success',
  CreateDepartmentFailureApi = '[Department API] Create Department Failure',
  UpdateDepartmentApi = '[Department API] Update Department',
  UpdateDepartmentSuccessApi = '[Department API] Update Department Success',
  UpdateDepartmentFailureApi = '[Department API] Update Department Failure',
  DeleteDepartmentApi = '[Department API] Delete Department',
  DeleteDepartmentSuccessApi = '[Department API] Delete Department Success',
  DeleteDepartmentFailureApi = '[Department API] Delete Department Failure',
}

export class LoadDepartmentsApi implements Action {
  readonly type = DepartmentApiActionTypes.LoadDepartmentsApi;
  constructor(public payload: { params: any, isCA?: boolean } = { params: {} }) {}
}

export class LoadDepartmentsSuccessApi implements Action {
  readonly type = DepartmentApiActionTypes.LoadDepartmentsSuccessApi;
  constructor(public payload: { departments: Department[] }) {}
}

export class LoadDepartmentsFailureApi implements Action {
  readonly type = DepartmentApiActionTypes.LoadDepartmentsFailureApi;
  constructor(public payload: { message: string }) {}
}

export class LoadDepartmentApi implements Action {
  readonly type = DepartmentApiActionTypes.LoadDepartmentApi;
  constructor(public payload: { id: string, isCA?: boolean }) {}
}

export class LoadDepartmentSuccessApi implements Action {
  readonly type = DepartmentApiActionTypes.LoadDepartmentSuccessApi;
  constructor(public payload: { department: Department, isCA?: boolean }) {}
}

export class LoadDepartmentFailureApi implements Action {
  readonly type = DepartmentApiActionTypes.LoadDepartmentFailureApi;
  constructor(public payload: { id: string; message: string }) {}
}

export class CreateDepartmentApi implements Action {
  readonly type = DepartmentApiActionTypes.CreateDepartmentApi;
  constructor(public payload: { department: Department, isCA?: boolean }) {}
}

export class CreateDepartmentSuccessApi implements Action {
  readonly type = DepartmentApiActionTypes.CreateDepartmentSuccessApi;
  constructor(public payload: { department: Department, isCA?: boolean }) {}
}

export class CreateDepartmentFailureApi implements Action {
  readonly type = DepartmentApiActionTypes.CreateDepartmentFailureApi;
  constructor(public payload: { id: string; message: string }) {}
}

export class UpdateDepartmentApi implements Action {
  readonly type = DepartmentApiActionTypes.UpdateDepartmentApi;
  constructor(public payload: { department: Department, isCA?: boolean }) {}
}

export class UpdateDepartmentSuccessApi implements Action {
  readonly type = DepartmentApiActionTypes.UpdateDepartmentSuccessApi;
  constructor(public payload: { department: Department, isCA?: boolean }) {}
}

export class UpdateDepartmentFailureApi implements Action {
  readonly type = DepartmentApiActionTypes.UpdateDepartmentFailureApi;
  constructor(public payload: { id: string; message: string }) {}
}

export class DeleteDepartmentApi implements Action {
  readonly type = DepartmentApiActionTypes.DeleteDepartmentApi;
  constructor(public payload: { id: string, isCA?: boolean }) {}
}

export class DeleteDepartmentSuccessApi implements Action {
  readonly type = DepartmentApiActionTypes.DeleteDepartmentSuccessApi;
  constructor(public payload: { id: string }) {}
}

export class DeleteDepartmentFailureApi implements Action {
  readonly type = DepartmentApiActionTypes.DeleteDepartmentFailureApi;
  constructor(public payload: { id: string; message: string }) {}
}

export type DepartmentApiActions =
  | LoadDepartmentsApi
  | LoadDepartmentsSuccessApi
  | LoadDepartmentsFailureApi
  | LoadDepartmentApi
  | LoadDepartmentSuccessApi
  | LoadDepartmentFailureApi
  | CreateDepartmentApi
  | CreateDepartmentSuccessApi
  | CreateDepartmentFailureApi
  | UpdateDepartmentApi
  | UpdateDepartmentSuccessApi
  | UpdateDepartmentFailureApi
  | DeleteDepartmentApi
  | DeleteDepartmentSuccessApi
  | DeleteDepartmentFailureApi;
